import handleUnassignTicketTypeFromModel from '%paysera_simple_event/js/seatSelectionIntegration/redux/reducers/handleUnassignTicketTypeFromModel';

export default handleUnassignTicketTypeFromModel;
